import { getEverLoggedIn } from 'dibs-cookie-jar';
import { localStorage } from 'dibs-browser-storage';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { getBuyerId } from 'dibs-cookie-jar';
import {
    LOGIN,
    REGISTER,
    DEFAULT_FLOW,
} from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import { USER_EMAIL } from '../constants/userConstants';

let relayEnvironment;
let reduxStore;

export function sharedLoginCheckSetUp({ store, environment }) {
    relayEnvironment = environment;
    reduxStore = store;
}

/**
 * Handles login logic
 * 1) Checks if user is logged-in
 * 2) If logged-in, calls onSuccess callback
 * if passed in
 * 3) If not logged-in, launches auth modal
 * and then calls onSuccess callback if passed in
 * @param {function} onSuccess - callback for when login succeeds
 * @param {string} onError - callback for when login fails
 */
export function sharedLoginCheck({ onSuccess = () => {}, onError = () => {}, authOptions }) {
    if (!relayEnvironment || !reduxStore) {
        throw new Error('Must call sharedLoginCheckSetUp before using sharedLoginCheck');
    }
    const userId = getBuyerId(document.cookie);
    if (userId) {
        return onSuccess({ userId });
    }
    return authModalLoader
        .show({
            flow: DEFAULT_FLOW,
            action: getEverLoggedIn(document.cookie) ? LOGIN : REGISTER,
            email: localStorage.getItem(USER_EMAIL),
            relayEnvironment,
            ...authOptions,
        })
        .then(res => {
            if (res.err) {
                return onError();
            }
            return onSuccess({ userId: res.userId });
        })
        .catch(e => onError(e));
}

export * from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
